<template>
  <!-- 预约记录卡片 -->
  <div class="cardBox" v-for="item in data" :key="item.reservationId">
    <rowItem :data="{ span: labelSpan, label: '预约创建时间：', value: item.createdTime }" :labelClass="titleClass" :valueClass="titleValue" />
    <div class="content">
      <template v-for="(rowObj, index) in item.list" :key="index">
        <rowItem :data="{ ...rowObj, span: labelSpan }" :rowClass="contentRow" />
      </template>
    </div>
    <div class="btnBox" v-if="item.btnData.length > 0">
      <BottomBtn :data="item.btnData" @click="clickBtn" align="between"></BottomBtn>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue'
import rowItem from '@/components/oab/row'
import BottomBtn from '@/components/order/BottomBtn'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    rowItem,
    BottomBtn
  },
  emits: ['click', 'clickBtn'],
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      labelSpan: 7,
      data: data.value,
      btnData: [],
      titleClass: ['fw'],
      titleValue: ['titleValue'],
      contentRow: ['contentRow']
    })
    const clickCard = v => {
      emit('click', v)
    }
    const clickBtn = v => {
      emit('clickBtn', v)
    }
    return {
      ...toRefs(state),
      clickCard,
      clickBtn
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  padding: 12px 20px 15px;
  margin-bottom: 8px;
  background-color: #fff;
  text-align: left;
  font-size: 12px;
  color: #999;
  :deep(.titleValue) {
    line-height: 18px;
  }
}
.content {
  padding: 12px 0;
  margin: 8px 0 14px;
  border-top: solid 1px #cccccc;
  border-bottom: solid 1px #cccccc;
}
.contentRow + .contentRow {
  margin-top: 8px;
}
</style>
